/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default [
  {
    header: "HOME", // header ใช้กับ items
    icon: "HomeIcon",
    // i18n: "Buy",
    items: [
      {
        url: "/",
        // url: "/dashboard",
        name: "Summary",
        slug: "home",
        // slug: "dashboard",
        // i18n: "Analytics",
        icon: "ActivityIcon"
      }
    ]
  },
  // {
  //   header: "DTO Function",
  //   icon: "UsersIcon",
  //   items: [
  //     {
  //       url: "/inbtracking",
  //       name: "DTOTracking",
  //       slug: "DTOTracking",
  //       icon: "SearchIcon"
  //     },
  //     {
  //       slug: "Inbound",
  //       name: "Inbound",
  //       icon: "ArrowDownIcon",
  //       // i18n: "GetMoney",
  //       submenu: [
  //         {
  //           url: "/DTOCMANImport",
  //           slug: "From Border",
  //           name: "From Border"
  //         },
  //         {
  //           url: "/dtofromdoms",
  //           slug: "From DOM",
  //           name: "From DOM"
  //         },
  //         {
  //           url: "/dtosabs",
  //           slug: "From Sea/Airport",
  //           name: "From Sea/Airport"
  //         },
  //       ]
  //     },
  //     {
  //       slug: "Outbound",
  //       name: "Outbound",
  //       icon: "ArrowUpIcon",
  //       // i18n: "GetMoney",
  //       submenu: [
  //         // {
  //         //   url: "/CMANExport",
  //         //   name: "By Truck",
  //         //   slug: "By Truck",
  //         //   icon: "TruckIcon"
  //         // },
  //         {
  //           url: "/DTOToDom",
  //           slug: "To DOM",
  //           name: "To DOM"
  //         },
  //         {
  //           url: "/DTOBorderExport",
  //           slug: "To Border",
  //           name: "To Border"
  //         },
  //       ]
  //     },
  //     {
  //       slug: "MovementZ1<->Z3",
  //       name: "MovementZ1<->Z3",
  //       icon: "RepeatIcon",
  //       // i18n: "GetMoney",
  //       submenu: [
  //         {
  //           url: "/dtotmoins",
  //           slug: "Inbound List",
  //           name: "Inbound List"
  //         },
  //         {
  //           url: "/dtotmoexs",
  //           slug: "Outbound List",
  //           name: "Outbound List"
  //         },
  //       ]
  //     },
  //     {
  //       slug: "Move",
  //       name: "Move",
  //       icon: "NavigationIcon",
  //       // i18n: "GetMoney",
  //       submenu: [
  //         {
  //           url: "/dtomoves",
  //           slug: "DTO-DTO",
  //           name: "DTO-DTO"
  //         },
  //       ]
  //     },
  //   ]
  // },
  {
    header: "Inbound",
    icon: "ArrowDownIcon",
    items: [
      {
        url: "/tmoins",
        name: "From TMO",
        slug: "From TMO",
        icon: "UserIcon"
      },
      {
        url: "/cmans",
        name: "From Border",
        slug: "From Border",
        icon: "TruckIcon"
      },
      {
        url: "/fromdoms",
        name: "From DOM",
        slug: "From DOM",
        icon: "CreditCardIcon"
      },
      {
        url: "/sabs",
        name: "From Sea/Airport",
        slug: "From Sea/Airport",
        icon: "SendIcon"
      },
      {
        url: "/Inbound",
        name: "Order",
        slug: "Order",
        icon: "ShoppingCartIcon"
      }
      // {
      //   url: "/putaway",
      //   name: "PutAway",
      //   slug: "PutAway",
      //   icon: "BoxIcon"
      // },
    ]
  },
  {
    header: "Outbound",
    icon: "ArrowUpIcon",
    items: [
      {
        url: "/tmoexs",
        name: "To TMO",
        slug: "To TMO",
        icon: "UserIcon"
      },
      // {
      //   url: "/cmansexs",
      //   name: "By Truck",
      //   slug: "By Truck",
      //   icon: "TruckIcon"
      // },
      {
        url: "/ToDom",
        name: "To DOM",
        slug: "To DOM",
        icon: "CreditCardIcon"
      },
      {
        url: "/BorderExport",
        name: "To Border",
        slug: "To Border",
        icon: "ColumnsIcon"
      },
      // {
      //   url: "/cpermits",
      //   name: "CustomsPermit",
      //   slug: "CustomsPermit",
      //   icon: "SendIcon"
      // },
      {
        slug: "CustomsPermit",
        name: "CustomsPermit",
        icon: "SendIcon",
        // i18n: "GetMoney",
        submenu: [
          {
            url: "/cpermits",
            slug: "CustomsPermit Manual",
            name: "CustomsPermit Manual"
          },
          {
            url: "/customspermit",
            slug: "CustomsPermit API",
            name: "CustomsPermit API"
          }
        ]
      },
      {
        url: "/outbound",
        name: "Order",
        slug: "Order",
        icon: "ShoppingCartIcon"
      }
      // {
      //   url: "/picking",
      //   name: "Picking",
      //   slug: "Picking",
      //   icon: "ArchiveIcon"
      // },
      // {
      //   url: "/ships",
      //   name: "Ships",
      //   slug: "Ships",
      //   icon: "CheckIcon"
      // },
    ]
  },
  // {
  //   header: "Move",
  //   icon: "NavigationIcon",
  //   items: [
  //     {
  //       url: "/reportadmin",
  //       name: "Main",
  //       slug: "Main",
  //       icon: "CreditCardIcon"
  //     },
  //     {
  //       url: "/reportadmin",
  //       name: "Detail",
  //       slug: "Detail",
  //       icon: "MenuIcon"
  //     },
  //   ]
  // },
  {
    header: "InboundTracking",
    icon: "TargetIcon",
    items: [
      {
        url: "/inbtracking",
        name: "Main",
        slug: "Main",
        icon: "CreditCardIcon"
      }
    ]
  },
  {
    header: "Overtime Goods",
    icon: "ClockIcon",
    items: [
      {
        url: "/lista",
        name: "ListA",
        slug: "ListA",
        icon: "AlertTriangleIcon"
      },
      {
        url: "/listfsubmit",
        name: "ListF_Submit",
        slug: "ListF_Submit",
        icon: "CheckIcon"
      },
      {
        url: "/listf",
        name: "ListF",
        slug: "ListF",
        icon: "AlertCircleIcon"
      }
    ]
  },
  {
    header: "Locations",
    icon: "CompassIcon",
    items: [
      {
        url: "/locations",
        name: "Main",
        slug: "Main",
        icon: "CreditCardIcon"
      }
    ]
  },
  // {
  //   header: "Delivery Order",
  //   icon: "ClipboardIcon",
  //   items: [
  //     {
  //       url: "/dlvorders",
  //       name: "DeliveryOrder",
  //       slug: "DeliveryOrder",
  //       icon: "TruckIcon"
  //     },
  //   ]
  // },
  {
    header: "ระบบรายงาน",
    icon: "BookOpenIcon",
    items: [
      {
        url: "/balanceReport",
        name: "BalanceReport",
        slug: "BalanceReport",
        icon: "CreditCardIcon"
      },
      {
        slug: "InboundReport",
        name: "InboundReport",
        icon: "CpuIcon",
        // i18n: "GetMoney",
        submenu: [
          {
            url: "/reportinboundall",
            slug: "Inbound All",
            name: "Inbound All"
          },
          // {
          //   url: "/reportinboundtmo",
          //   slug: "Inbound TMO",
          //   name: "Inbound TMO"
          // },
          {
            url: "/reportinboundcargo",
            slug: "Inbound Cargo",
            name: "Inbound Cargo"
          }
        ]
      },
      {
        slug: "OutboundReport",
        name: "OutboundReport",
        icon: "BriefcaseIcon",
        // i18n: "GetMoney",
        submenu: [
          {
            url: "/reportoutboundall",
            slug: "Outbound All",
            name: "Outbound All"
          },
          // {
          //   url: "/reportoutboundtmo",
          //   slug: "Outbound TMO",
          //   name: "Outbound TMO",
          // },
          {
            url: "/reportoutboundcargo",
            slug: "Outbound Cargo",
            name: "Outbound Cargo"
          }
        ]
      },
      {
        url: "/reportmovements",
        name: "Z1Z3 Report",
        slug: "MovementReport",
        icon: "CrosshairIcon"
      }
    ]
  },
  {
    header: "Change Request",
    icon: "EditIcon",
    items: [
      {
        url: "/chrequests",
        name: "Main",
        slug: "Main",
        icon: "CreditCardIcon"
      }
    ]
  },
  {
    header: "Billing",
    icon: "DollarSignIcon",
    items: [
      {
        url: "/invperiods",
        name: "InvoicePeriod",
        slug: "InvoicePeriod",
        icon: "CalendarIcon"
      },
      {
        url: "/handlingcharges",
        name: "HandlingCharge",
        slug: "HandlingCharge",
        icon: "ShoppingCartIcon"
      },
      {
        url: "/inbhandlings",
        name: "HandlingMap",
        slug: "HandlingMap",
        icon: "CopyIcon"
      },
      {
        url: "/invoices",
        name: "Invoice",
        slug: "Invoice",
        icon: "DollarSignIcon"
      },
      // {
      //   url: "/invoicesrec",
      //   name: "InvoiceReconcile",
      //   slug: "InvoiceReconcile",
      //   icon: "CheckIcon"
      // },
      {
        url: "/receipts",
        name: "Receipt",
        slug: "Receipt",
        icon: "FileTextIcon"
      },
      // {
      //   url: "/receiptsrec",
      //   name: "ReceiptsReconcile",
      //   slug: "ReceiptsReconcile",
      //   icon: "CheckSquareIcon"
      // },
      // {
      //   url: "/cninvoices",
      //   name: "CreditNote",
      //   slug: "CreditNote",
      //   icon: "DeleteIcon"
      // },
      {
        slug: "cninvoicess",
        name: "cninvoicess",
        icon: "DeleteIcon",
        submenu: [
          {
            url: "/cninvoices",
            slug: "CreditNote",
            name: "CreditNote"
          },
          // {
          //   url: "/cninvoicesnorcv",
          //   slug: "CreditNoteNoReceipt",
          //   name: "CreditNoteNoReceipt"
          // },
          {
            url: "/cninvoiceapp",
            slug: "CreditNoteApprove",
            name: "CreditNoteApprove"
          }
        ]
      },
      // {
      //   url: "/cninvoicesrec",
      //   name: "CreditNoteReconcile",
      //   slug: "CreditNoteReconcile",
      //   icon: "CheckCircleIcon"
      // },
      {
        name: "billingsReport",
        icon: "DollarSignIcon",
        submenu: [
          {
            url: "/invoicesReport",
            slug: "invoicesReport",
            name: "InvoicesReport",
          },
          {
            url: "/receiptsReport",
            slug: "receiptsReport",
            name: "receiptsReport",
          },
          {
            url: "/creditnoteReport",
            slug: "creditnoteReport",
            name: "creditnoteReport",
          },
          {
            url: "/volumeReport",
            slug: "volumeReport",
            name: "volumeReport",
          },
        ]
      }
    ]
  },
  {
    header: "ตั้งค่าโปรแกรม",
    icon: "SettingsIcon",
    items: [
      // {
      //   url: "/banks",
      //   slug: "banks",
      //   name: "จัดการข้อมูลธนาคาร",
      //   icon: "DollarSignIcon",
      //   // i18n: "GetMoney",
      //   submenu: [
      //     {
      //       url: "/banks",
      //       slug: "banks",
      //       name: "ธนาคารหลัก",
      //       icon: "DollarSignIcon"
      //     },
      //     {
      //       url: "/banksweb",
      //       slug: "banksweb",
      //       name: "ธนาคารเว็บ",
      //       icon: "DollarSignIcon"
      //     }
      //   ]
      // },
      {
        name: "ผู้ดูแลระบบ",
        icon: "UserCheckIcon",
        // i18n: "PayMoney",
        submenu: [
          {
            url: "/companygroups",
            name: "CompanyGroup",
            slug: "companygroups",
            icon: "LinkIcon"
          },
          {
            url: "/cargomovements",
            name: "CargoMovement",
            slug: "cargomovements",
            icon: "MoveIcon"
          },
          {
            url: "/goodscargotypes",
            name: "GoodsCargoType",
            slug: "goodscargotypes",
            icon: "ArchiveIcon"
          },
          {
            url: "/adminusers",
            slug: "adminจัดการสมาชิก",
            name: "จัดการสมาชิก",
            icon: "UsersIcon"
          },
          // {
          //   url: "/adminroles",
          //   slug: "adminroles",
          //   name: "จัดการสิทธิ",
          //   icon: "UnlockIcon"
          //   // i18n: "GetMoney",
          // },
          // {
          //   url: "/adminsyslogs",
          //   slug: "adminsyslogs",
          //   name: "Admin Logs",
          //   icon: "ArchiveIcon"
          //   // i18n: "GetMoney",
          // },
          {
            slug: "Admin Logs",
            name: "Admin Logs",
            icon: "ArchiveIcon",
            // i18n: "GetMoney",
            submenu: [
              {
                url: "/adminsyslogs",
                slug: "List",
                name: "List"
              },
              {
                url: "/adminsyslogsreport",
                slug: "Report",
                name: "Report"
              }
            ]
          },
          
        ]
      },
      {
        name: "FDMS",
        icon: "CodeIcon",
        // i18n: "PayMoney",
        submenu: [
          {
            url: "/fdmsexb",
            slug: "fdmsexb",
            name: "FDMSOutboundService",
            icon: "ArchiveIcon"
            // i18n: "GetMoney",
          },
          {
            url: "/fdmsinb",
            slug: "fdmsinb",
            name: "FDMSInboundService",
            icon: "ArchiveIcon"
            // i18n: "GetMoney",
          },
        ]
      },
      {
        name: "Queue",
        icon: "ClockIcon",
        // i18n: "PayMoney",
        submenu: [
          {
            url: "/qconfig",
            slug: "qconfig",
            name: "QueueConfig",
            icon: "ArchiveIcon"
            // i18n: "GetMoney",
          },
          {
            url: "/qinv",
            slug: "qinv",
            name: "QueueInvoiceRec",
            icon: "ArchiveIcon"
            // i18n: "GetMoney",
          },
          {
            url: "/qrec",
            slug: "qrec",
            name: "QueueReceiptRec",
            icon: "ArchiveIcon"
            // i18n: "GetMoney",
          },
          {
            url: "/qdownloadice",
            slug: "qdownloadice",
            name: "QueueDownloadICE",
            icon: "ArchiveIcon"
            // i18n: "GetMoney",
          },
          {
            url: "/qcustomer",
            slug: "qcustomer",
            name: "QueueCustomer",
            icon: "ArchiveIcon"
            // i18n: "GetMoney",
          },
          {
            url: "/zerostock",
            slug: "zerostock",
            name: "QueueZerostock",
            icon: "ArchiveIcon"
            // i18n: "GetMoney",
          },
        ]
      },
      {
        url: "/messagefunctions",
        name: "Messagefunction",
        slug: "messagefunctions",
        icon: "MailIcon"
      },
      {
        url: "/processindicators",
        name: "ProcessIndicator",
        slug: "processindicators",
        icon: "CodeIcon"
      },
      {
        url: "/cartypes",
        name: "CarType",
        slug: "cartypes",
        icon: "TruckIcon"
      },
      {
        url: "/businesspartners",
        name: "BusinessPartner",
        slug: "businesspartners",
        icon: "UsersIcon"
      },
      {
        url: "/shippings",
        name: "Shipping",
        slug: "shippings",
        icon: "UserIcon"
      },
      // {
      //   url: "/zones",
      //   name: "Zone",
      //   slug: "zones",
      //   icon: "TriangleIcon"
      // },
      {
        url: "/warehouses",
        name: "Warehouse",
        slug: "warehouses",
        icon: "HomeIcon"
      },
      {
        url: "/sections",
        name: "Section",
        slug: "sections",
        icon: "AlignJustifyIcon"
      },
      {
        url: "/exptypes",
        name: "Export Type",
        slug: "exptypes",
        icon: "CornerRightUpIcon"
      },
      {
        url: "/transmodes",
        name: "Transport Mode",
        slug: "transmodes",
        icon: "NavigationIcon"
      },
      {
        url: "/protypes",
        name: "Product Type",
        slug: "protypes",
        icon: "ArchiveIcon"
      },
      {
        url: "/countrys",
        name: "Country",
        slug: "countrys",
        icon: "GlobeIcon"
      },
      {
        url: "/provinces",
        name: "Province",
        slug: "provinces",
        icon: "CompassIcon"
      },
      // {
      //   url: "/ports",
      //   name: "Port",
      //   slug: "ports",
      //   icon: "MapIcon"
      // },
      {
        url: "/customsports",
        name: "CustomsPort",
        slug: "customsports",
        icon: "PocketIcon"
      },
      {
        url: "/packages",
        name: "Package",
        slug: "packages",
        icon: "PackageIcon"
      },
      {
        url: "/tmotypes",
        name: "TmoType",
        slug: "tmotypes",
        icon: "TagIcon"
      },
      {
        url: "/constates",
        name: "ContainerStateCode",
        slug: "constates",
        icon: "TypeIcon"
      },
      {
        url: "/contypesize",
        name: "ContainerTypeSize",
        slug: "contypesize",
        icon: "ServerIcon"
      }
    ]
  }
];
